// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const AutocompleteConfig = () => (config: any) => ({
   libhash: config.info.libhash,
   enabled: config.widgets.enable_autocomplete,
   enhancedEnabled: config.widgets.enable_enhanced_autocomplete,
   dbRecsEnabled: config.site.db_recommender_enabled,
   url: config.autocomplete.url,
   numResults: config.autocomplete.num_results,
   topicSourcePriority: config.info.topics?.topicSourcePriority,
   topicsDisplay: config.topics.topics_display,
   azSearchUrl: config.autocomplete.az_search_url
})

angular.module('summonApp.factories.configs')
   .factory('autocompleteConfig', AutocompleteConfig)
